import React, { useState, useEffect } from "react";
import "./AdminShared.css";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";

const AddCourse = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    price: "",
    description: "",
    gst: "",
    days: "",
    aboutCourse: "",
    eligibility: "",
    courseIncludes: "",
    courseExcludes: "",
    mainImage: null,
    galleryImages: [],
  });

  const [submitting, setSubmitting] = useState(false);
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("adminInfo");
    if (!token) {
      navigate("/admin");
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "mainImage" && files?.length) {
      setFormData((prev) => ({ ...prev, mainImage: files[0] }));
      setPreview(URL.createObjectURL(files[0]));
    } else if (name === "galleryImages") {
      setFormData((prev) => ({ ...prev, galleryImages: Array.from(files) }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const data = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (!value) return;
      if (key === "galleryImages") {
        value.forEach((img) => data.append("galleryImages", img));
      } else {
        data.append(key, value);
      }
    });

    try {
      const res = await fetch(`${API_BASE_URL}/api/courses`, {
        method: "POST",
        body: data,
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem("adminInfo") || "{}").token}`,
        },
      });

      if (res.ok) {
        alert("✅ Operational Resource Initialized!");
        navigate("/admin/courses");
      } else {
        const errorData = await res.json();
        alert("❌ Initialization Failed: " + (errorData.message || res.statusText));
      }
    } catch (error) {
      console.error("Error submitting course:", error);
      alert("❌ Critical Server Error");
    }
    setSubmitting(false);
  };

  return (
    <div className="admin-list-container">
      <header className="admin-list-header">
        <div className="header-left-group">
          <button className="admin-back-btn" onClick={() => navigate("/admin/panel")}>←</button>
          <img src="/logo.png" alt="FlyTutor" className="admin-header-logo" />
          <h1 className="admin-header-title">Resource Deployment</h1>
        </div>
        <div className="module-badge">New Course</div>
      </header>

      <div className="admin-list-content">
        <div className="admin-form-card">
          <div className="ap-welcome">
            <h1>Initialize Course</h1>
            <p>Deploy a new decentralized aviation training resource to the global registry.</p>
          </div>

          <form className="admin-form-elite" onSubmit={handleSubmit}>
            <label>
              Operational Name
              <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="e.g. Advanced Drone Pilot RPC" required />
            </label>

            <label>
              Unit Price (INR)
              <input type="number" name="price" value={formData.price} onChange={handleChange} placeholder="0.00" required />
            </label>

            <label className="full-width-field">
              Technical Description
              <textarea name="description" value={formData.description} onChange={handleChange} placeholder="Brief summary for indexing..." required />
            </label>

            <label>
              Tax Identification (GST)
              <input type="text" name="gst" value={formData.gst} onChange={handleChange} placeholder="18% / Exempt / etc." required />
            </label>

            <label>
              Deployment Duration (Days)
              <input type="number" name="days" value={formData.days} onChange={handleChange} placeholder="Total calendar days" required />
            </label>

            <label className="full-width-field">
              About the Operational Block
              <textarea name="aboutCourse" value={formData.aboutCourse} onChange={handleChange} placeholder="Detailed course breakdown..." required />
            </label>

            <label className="full-width-field">
              Eligibility Parameters
              <textarea name="eligibility" value={formData.eligibility} onChange={handleChange} placeholder="Prerequisites for enrollment..." required />
            </label>

            <label>
              Resource Inclusions
              <textarea name="courseIncludes" value={formData.courseIncludes} onChange={handleChange} placeholder="What is provided..." required />
            </label>

            <label>
              Resource Exclusions
              <textarea name="courseExcludes" value={formData.courseExcludes} onChange={handleChange} placeholder="What is not provided..." required />
            </label>

            <label>
              Primary Asset Image
              <input type="file" name="mainImage" accept="image/*" onChange={handleChange} required />
            </label>

            <label>
              Logistical Gallery (Max 4)
              <input type="file" name="galleryImages" accept="image/*" onChange={handleChange} multiple />
            </label>

            {preview && (
              <div className="img-preview-box">
                <img src={preview} alt="Primary Preview" className="preview-thumb" />
              </div>
            )}

            <div className="admin-submit-area">
              <button type="submit" className="btn-primary-elite" disabled={submitting}>
                {submitting ? "Deploying Core..." : "Deplay Resource"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddCourse;
